import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const LuckyOrangeTracker = () => {
  const location = useLocation();

useEffect(() => {

    let interval: NodeJS.Timeout;
    const triggerPageview = () => {
        if (window.LO && typeof window.LO.pageview === "function") {
        window.LO.pageview();
        clearInterval(interval);
        }
    };

    interval = setInterval(triggerPageview, 500);

    return () => clearInterval(interval);
 
}, [location.pathname]);

  return null;
};

export default LuckyOrangeTracker;